export type VoltageKind = 'ac' | 'dc';

export interface FormatVoltageOptions {
  fallback?: string;
  kvDecimals?: number;
  vDecimals?: number;
}

const KV_THRESHOLD_V = 2000;

export function formatVoltage(
  value: number | null | undefined,
  kind: VoltageKind,
  opts: FormatVoltageOptions = {}
): string {
  const { fallback = '—', kvDecimals = 2, vDecimals = 0 } = opts;
  if (value == null || !Number.isFinite(value)) return `${fallback} V`;
  if (kind === 'ac' && Math.abs(value) >= KV_THRESHOLD_V) {
    return `${(value / 1000).toFixed(kvDecimals)} kV`;
  }
  return `${value.toFixed(vDecimals)} V`;
}
